<template>
  <nav class="flex flex-col gap-2 px-spacing_9 pb-spacing_7 pt-2">
    <div class="flex items-center justify-between">
      <NuxtLink :to="paths.home">
        <img
          v-if="$appConfig?.web_icon_url"
          class="h-6"
          :src="$appConfig.web_icon_url"
          :alt="`${$appName}-logo`"
        />
      </NuxtLink>

      <ButtonGroup :cart-items-no />
    </div>

    <div class="flex w-full items-center gap-1">
      <IconButton
        v-if="$features?.brands || $features?.bundles || $features?.categories"
        name="ic-menu"
        :aria-label="$t('common.actions.open_menu')"
        aria-haspopup="menu"
        :c_style="{ type: 'ghost' }"
        @click="$emit('openDrawer')"
      />

      <Searchbar
        v-if="enableSearch"
        v-model="searchValue"
        class="search max-w-[835px] flex-1"
        :placeholder="$t('common.actions.search')"
        :autocompleteItems="searchAutocompleteValues"
        @clear-all="$emit('clearAllSearches')"
        @remove-item="$emit('removeFromRecentSearches', $event)"
        @input="$emit('getMatchingKeywords', $event)"
        @submit="$emit('searchSubmit', $event)"
      />
    </div>
  </nav>
</template>

<script setup lang="ts">
import type { AutocompleteType } from "~/types/schemas/common/Molecule/searchbar";
import IconButton from "~/components/common/Atom/IconButton.vue";
import paths from "~/constants/paths";
import Searchbar from "~/components/common/Molecule/Searchbar.vue";
import ButtonGroup from "~/components/informative/Organism/Header/ButtonGroup.vue";

const searchValue = defineModel<string>("searchValue", { default: "" });

defineProps<{
  searchAutocompleteValues: AutocompleteType;
  cartItemsNo: number | string;
  enableSearch?: boolean;
}>();

defineEmits<{
  openDrawer: [];
  clearAllSearches: [];
  removeFromRecentSearches: [value: string];
  getMatchingKeywords: [value: string];
  searchSubmit: [value: string];
  setLang: [lang: string];
}>();
</script>
